// Builders for special QR code payloads (Wi-Fi and SEPA/EPC "GiroCode").

// --- Wi-Fi -----------------------------------------------------------------
// Format: WIFI:T:<WPA|WEP|nopass>;S:<ssid>;P:<password>;H:<true>;;
// Special characters in SSID/password must be escaped with a backslash.
export function escapeWifi(s = '') {
  return String(s).replace(/([\\;,:"])/g, '\\$1');
}

export function buildWifiPayload({ ssid = '', password = '', encryption = 'WPA', hidden = false } = {}) {
  if (!String(ssid).trim()) return '';
  const enc = encryption === 'nopass' ? 'nopass' : encryption; // WPA | WEP | nopass
  const S = escapeWifi(ssid);
  let out = `WIFI:T:${enc};S:${S};`;
  if (enc !== 'nopass') out += `P:${escapeWifi(password)};`;
  if (hidden) out += 'H:true;';
  out += ';';
  return out;
}

// --- IBAN checksum (ISO 13616, mod-97) -------------------------------------
export function isValidIban(iban = '') {
  const s = String(iban).replace(/\s+/g, '').toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(s)) return false;
  if (s.length < 15 || s.length > 34) return false;
  const rearranged = s.slice(4) + s.slice(0, 4);
  let remainder = 0;
  for (let i = 0; i < rearranged.length; i++) {
    const ch = rearranged[i];
    const code = ch >= 'A' && ch <= 'Z' ? (ch.charCodeAt(0) - 55).toString() : ch;
    for (let j = 0; j < code.length; j++) {
      remainder = (remainder * 10 + (code.charCodeAt(j) - 48)) % 97;
    }
  }
  return remainder === 1;
}

// --- SEPA / EPC GiroCode ---------------------------------------------------
// EPC069-12 "BCD" payload used by GiroCode. Version 002 => BIC optional.
export function buildEpcPayload({ name = '', iban = '', bic = '', amount = '', purpose = '' } = {}) {
  const cleanIban = String(iban).replace(/\s+/g, '').toUpperCase();
  const cleanName = String(name).trim();
  if (!cleanName || !cleanIban) return '';

  let amt = '';
  if (String(amount).trim() !== '') {
    const num = parseFloat(String(amount).replace(',', '.'));
    if (!Number.isNaN(num) && num > 0) amt = 'EUR' + num.toFixed(2);
  }

  const lines = [
    'BCD',                                   // 1 Service Tag
    '002',                                   // 2 Version (BIC optional)
    '1',                                     // 3 Character set: 1 = UTF-8
    'SCT',                                   // 4 Identification
    String(bic).replace(/\s+/g, '').toUpperCase(), // 5 BIC (optional)
    cleanName.slice(0, 70),                  // 6 Beneficiary name
    cleanIban,                               // 7 IBAN
    amt,                                     // 8 Amount (EUR + value)
    '',                                      // 9 Purpose code
    '',                                      // 10 Structured remittance
    String(purpose).slice(0, 140),           // 11 Unstructured remittance (Verwendungszweck)
    '',                                      // 12 Beneficiary-to-originator info
  ];
  // Trailing empty lines are allowed to be omitted (keep at least 7).
  while (lines.length > 7 && lines[lines.length - 1] === '') lines.pop();
  return lines.join('\n');
}
